module.exports = __webpack_public_path__ + "static/media/bg-2.01eb2ebe.png";